import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';

import { useModelsList, useCustomersList } from '@hooks/API/Contact/UseContactsList';

import GlobalSearch from '@components/_LayoutComponents/Header/GlobalSearch/GlobalSearch';

import StyleVariables from '@components/Gui/StyleVariables';

const GlobalSearchWrapperBooking = () => {
    const { data: models, isFetching: loadingModels } = useModelsList();
    const { data: customers, isFetching: loadingCustomers } = useCustomersList();

    const navigate = useNavigate();

    const sources = useMemo(() => {
        if (loadingModels || loadingCustomers) {
            return [];
        }
        const source_models = models
            ? models
                  .filter((model) => model.ST === 4)
                  .map((model) => ({
                      ID: model.ID,
                      cover: model.CG,
                      subtype: 4,
                      showValue: `${model.N.trim()} ${model.S ? model.S.trim() : ''}`,
                      searchValue: model._normalizedFullName,
                      secondLine: model.MAN,
                      searchGroup: 'models',
                  }))
            : [];
        const source_scouting = models
            ? models
                  .filter((model) => model.ST === 5)
                  .map((model) => ({
                      ID: model.ID,
                      cover: model.CG,
                      subtype: 5,
                      showValue: `${model.N.trim()} ${model.S ? model.S.trim() : ''}`,
                      searchValue: model._normalizedFullName,
                      secondLine: model.MAN,
                      searchGroup: 'scouting',
                  }))
            : [];
        const source_clients = customers
            ? customers
                  .filter((customer) => customer.ST === 1)
                  .map((customer) => ({
                      ID: customer.ID,
                      cover: null,
                      subtype: 1,
                      showValue: customer.N,
                      searchValue: customer._normalizedFullName,
                      secondLine: null,
                      searchGroup: 'clients',
                  }))
            : [];
        const source_agencies = customers
            ? customers
                  .filter((customer) => customer.ST === 2)
                  .map((customer) => ({
                      ID: customer.ID,
                      cover: null,
                      subtype: 2,
                      showValue: customer.N,
                      searchValue: customer._normalizedFullName,
                      secondLine: null,
                      searchGroup: 'agencies',
                  }))
            : [];
        const source_services = customers
            ? customers
                  .filter((customer) => customer.ST === 3)
                  .map((customer) => ({
                      ID: customer.ID,
                      cover: null,
                      subtype: 3,
                      showValue: customer.N,
                      searchValue: customer._normalizedFullName,
                      secondLine: null,
                      searchGroup: 'services',
                  }))
            : [];
        return [...source_models, ...source_scouting, ...source_clients, ...source_agencies, ...source_services];
    }, [models, customers, loadingModels, loadingCustomers]);

    const onSearchContact = (contactInfo) => {
        if (contactInfo.type === 'model') {
            navigate(`/model/${contactInfo.ID}/all/all`); //?clear_qf=true
        } else {
            navigate(`/customer/${contactInfo.ID}/all/all`); //?clear_qf=true
        }
    };

    if (loadingModels || loadingCustomers) {
        return <BeatLoader color={StyleVariables.PrimaryColor} size={8} />;
    }
    return <GlobalSearch sources={sources} onSearchContact={onSearchContact} />;
};

export default GlobalSearchWrapperBooking;
